<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.3335 0V9.33333H22.6668L10.6668 24V14.6667H1.3335L13.3335 0Z"
            fill="url(#paint0_linear_19942_339477)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_19942_339477"
                x1="1.17188"
                y1="13.5"
                x2="22.5052"
                y2="13.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#CCBB86" />
                <stop
                    offset="0.487274"
                    stop-color="#DBCC93"
                    stop-opacity="0.95"
                />
                <stop offset="1" stop-color="#AF9B62" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "LightningBoltGoldIcon",
};
</script>
